import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SiInfoPageComponent } from '@siemens/element-ng/info-page';

declare global {
  interface Window {
    psse?: {
      isElectron: boolean;
      executePSSECode: (code: string) => Promise<string>;
    };
  }
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SiInfoPageComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  readonly isElectron = signal((globalThis as unknown as Window).psse?.isElectron === true);
}
